export default __webpack_public_path__ + "static/media/burgerboat-font.3e9d816e.woff";